import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import VideoHero from '../components/shared/VideoHero';
import PartnersSection from '../components/PartnerSection'; // Dosya yolunu kontrol edin

const Corporate = () => {
  const contactUrl = "https://studio.littlehibba.com/contact";

  // Resim Yolları (public klasörü içinde)
  const imgPath = {
    cover: "/images/corporate/cover2.jpg",
    sketch: "/images/corporate/sketch.jpg",
    colored: "/images/corporate/coloredpage.jpg"
  };

  const steps = [
    {
      title: "1. Discovery & Values Mapping",
      desc: "We begin with a structured discovery phase to understand your organisation’s values, tone, and intended audience. From this, we develop a clear story brief and creative direction."
    },
    {
      title: "2. Writer Sourcing & Story Development",
      desc: "We source a professional writer aligned with your themes, develop the narrative arc, and refine the manuscript to industry standards ensuring it works emotionally and educationally."
    },
    {
      title: "3. Illustration & Visual World-Building",
      desc: "We manage professional illustrators to develop character designs and visual styles ensuring inclusivity and cultural care. The result is a visually rich book children connect with."
    },
    {
      title: "4. Full Book Production",
      desc: "We handle the complete production process including design, layout, print-ready files, ISBN guidance, and quality control. We can also advise on printing and materials."
    },
    {
      title: "5. Educational School Pack",
      desc: "To extend impact, we create a school-ready pack with teacher notes and activity sheets, allowing you to take the story into schools and communities with confidence."
    },
    {
      title: "6. Launch & Impact Support",
      desc: "We support internal or external book launches and community engagement ideas, ensuring the book is positioned effectively within your wider DEI or social impact strategy."
    }
  ];

  return (
    /* DÜZELTME 1: Tüm sayfayı saran div'e overflow-x: hidden verildi. 
       Bu, Navbar kaymasını ve yatay scroll oluşmasını kesin olarak engeller. */
    <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
      <Helmet>
        <title>Corporate Story Projects | Little Hibba</title>
        <meta 
          name="description" 
          content="Purpose-Led Books for Companies and Communities. We create bespoke children’s books rooted in your core mission, people, and purpose." 
        />
      </Helmet>

      {/* 1. Hero Bölümü */}
      <VideoHero 
        title="Corporate Story Projects" 
        tagline="Purpose-Led Books for Companies and Communities"
      />

      {/* 2. Giriş ve Felsefe */}
      <section className="corporate-intro-section py-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={10} lg={9}>
              <h2 className="cb-title mb-4">Legacy Storytelling</h2>
              <p className="lead text-muted mb-4">
                At Little Hibba, we believe stories are among the most powerful ways to pass on values, not just to children, but also to families and the wider community.
              </p>
              <p>
                For organisations that want their values to live beyond a policy document or a campaign slogan, we create bespoke children’s books rooted in your core mission.
              </p>
              
              <div className="quote-box mt-4 p-4 bg-light rounded shadow-sm border-start border-5 border-primary">
                <h5 className="fst-italic mb-0 text-dark">
                  "This is not branded merchandise. <br />
                  This is legacy storytelling."
                </h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 3. PARTNERS SECTION */}
      {/* Bu bölüm bazen genişlik sorunu yaratabilir, ana div'deki overflow-hidden bunu çözer. */}
      <PartnersSection />

      {/* 4. CASE STUDY: NHS PROJECT */}
      <section className="case-study-section py-5 bg-white">
        <Container>
            <div className="text-center mb-5">
                <span className="badge bg-primary bg-opacity-10 text-primary mb-2 px-3 py-2">RECENT WORK</span>
                <h2 className="mb-3">Case Study: NHS Organ Donation</h2>
                <p className="text-muted w-75 mx-auto">
                    We partnered with the NHS to create a culturally sensitive story about organ and blood donation, helping families navigate complex conversations through the power of storytelling.
                </p>
            </div>

            <Row className="align-items-center g-5">
                {/* DÜZELTME 2: Mobilde sıralama (Order) değiştirildi.
                   order-2: Mobilde 2. sırada (Altta)
                   order-lg-1: Masaüstünde 1. sırada (Solda)
                */}
                <Col lg={5} className="text-center order-2 order-lg-1">
                    <div className="position-relative shadow-lg rounded-3 overflow-hidden" style={{transform: 'rotate(-2deg)'}}>
                        <img 
                            src={imgPath.cover} 
                            alt="NHS Book Cover" 
                            className="img-fluid w-100"
                            style={{objectFit: 'cover'}}
                        />
                    </div>
                    <p className="mt-3 small text-muted fst-italic">Final Book Cover</p>
                </Col>

                {/* order-1: Mobilde 1. sırada (Üstte)
                   order-lg-2: Masaüstünde 2. sırada (Sağda)
                */}
                <Col lg={7} className="order-1 order-lg-2">
                    <h3 className="mb-4">From Concept to Reality</h3>
                    <p className="mb-4">
                        Our process involves detailed character development and storyboarding. Here you can see how a page evolves from an initial pencil sketch to a fully vibrant, illustrated scene.
                    </p>
                    
                    <Row className="g-3">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-2">
                                    <div className="overflow-hidden rounded position-relative">
                                        <span className="position-absolute top-0 start-0 bg-dark text-white text-xs px-2 py-1 m-2 rounded small opacity-75">Step 1: Sketch</span>
                                        <img 
                                            src={imgPath.sketch} 
                                            alt="Initial Sketch" 
                                            className="img-fluid rounded hover-zoom" 
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Body className="p-2">
                                    <div className="overflow-hidden rounded position-relative">
                                        <span className="position-absolute top-0 start-0 bg-success text-white text-xs px-2 py-1 m-2 rounded small opacity-90">Step 2: Deciding on colours</span>
                                        <img 
                                            src={imgPath.colored} 
                                            alt="Final Colored Page" 
                                            className="img-fluid rounded" 
                                        />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
      </section>

      {/* 5. What We Create */}
      <section className="what-we-create py-5 bg-light-section">
        <Container>
          <Row className="align-items-center">
            <Col md={12} className="text-center mb-5">
              <h2 className="mb-3">What We Create</h2>
              <p className="text-muted w-75 mx-auto">
                Each project is carefully shaped to ensure the story feels authentic, age-appropriate, and timeless.
              </p>
            </Col>
            
            <Col md={10} lg={8} className="mx-auto">
              <div className="bg-white p-4 p-md-5 rounded shadow-sm border border-light">
                <h5 className="mb-4 fw-bold text-primary text-center">We develop custom children’s books that reflect:</h5>
                <Row>
                    <Col md={6}>
                        <ul className="list-unstyled">
                            <li className="d-flex mb-3">
                                <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                                <span>Your core values and ethical principles</span>
                            </li>
                            <li className="d-flex mb-3">
                                <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                                <span>Messages for employees & clients</span>
                            </li>
                        </ul>
                    </Col>
                    <Col md={6}>
                         <ul className="list-unstyled">
                            <li className="d-flex mb-3">
                                <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                                <span>Themes of empathy, identity & care</span>
                            </li>
                            <li className="d-flex mb-3">
                                <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                                <span>Educational resources & gifting</span>
                            </li>
                        </ul>
                    </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 6. Premium Paket Detayları (Steps) */}
      <section className="premium-package-section py-5">
        <Container>
          <div className="text-center mb-5">
            <span className="badge bg-warning text-dark mb-2 px-3 py-2">Our Service</span>
            <h2 className="cb-title">Premium Corporate Book Package</h2>
            <p className="text-muted mx-auto" style={{maxWidth: '700px'}}>
              This is our most comprehensive offering, designed for organisations that want a complete, professionally delivered project.
            </p>
          </div>

          <Row className="g-4">
            {steps.map((step, index) => (
              <Col lg={4} md={6} key={index}>
                <Card className="h-100 border-0 shadow-sm hover-shadow transition-all">
                  <Card.Body className="p-4">
                    <div className="mb-3 text-primary fs-1 opacity-25 fw-bold font-monospace">
                      0{index + 1}
                    </div>
                    <h5 className="fw-bold mb-3">{step.title.split('. ')[1]}</h5>
                    <p className="text-muted small mb-0">
                      {step.desc}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* 7. Who & Why */}
      <section className="who-why-section py-5 bg-light">
        <Container>
          <Row className="g-5">
            <Col md={6}>
              <h3 className="mb-4">Who This Is For</h3>
              <ul className="list-unstyled">
                {[
                  "Companies investing in DEI, ESG, or social impact initiatives",
                  "Organisations working with families, education, or health",
                  "Brands that want to give something thoughtful and enduring",
                ].map((item, i) => (
                  <li key={i} className="d-flex align-items-start mb-3">
                    <i className="bi bi-arrow-right-circle text-primary me-3 mt-1"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Col>

            <Col md={6}>
              <h3 className="mb-4">Why Little Hibba</h3>
              <ul className="list-unstyled">
                {[
                  "Deep experience in children’s publishing and education",
                  "A values-first approach rooted in care and quality",
                  "End-to-end delivery — from idea to printed book",
                ].map((item, i) => (
                  <li key={i} className="d-flex align-items-start mb-3">
                    <i className="bi bi-star-fill text-warning me-3 mt-1"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      {/* 8. CTA */}
      <section className="final-cta py-5 text-center bg-primary text-white">
        <Container>
          <Row className="justify-content-center">
            <Col md={8}>
              <h2 className="mb-3 text-white">Let’s Build a Story That Lasts</h2>
              <p className="lead mb-4 text-white-50">
                Ready to turn your values into a legacy?
              </p>
              <Button 
                href={contactUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="light" 
                size="lg" 
                className="px-5 py-3 rounded-pill fw-bold shadow text-primary"
              >
                Start a Conversation
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Corporate;